import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { InternalLayout } from "@/components/InternalLayout";
import { StatusPill } from "@/components/StatusPill";
import { fmtDate } from "@/lib/constants";
import { Activity, Play } from "lucide-react";
import { toast } from "sonner";

export default function Operations() {
  const [projects, setProjects] = useState([]);
  const [projectId, setProjectId] = useState("");
  const [checks, setChecks] = useState([]);

  useEffect(() => {
    api.get("/projects").then((r) => {
      setProjects(r.data);
      const url = new URL(window.location.href);
      setProjectId(url.searchParams.get("project") || r.data[0]?.project_id || "");
    });
  }, []);

  const load = async (id) => {
    if (!id) return;
    const r = await api.get(`/projects/${id}/health-checks`);
    setChecks(r.data);
  };
  useEffect(() => { load(projectId); }, [projectId]);

  const trigger = async (type) => {
    await api.post(`/projects/${projectId}/health-checks`, { type });
    toast.success("Health-Check gestartet");
    load(projectId);
  };

  return (
    <InternalLayout>
      <div className="mb-6">
        <div className="font-mono text-[11px] uppercase tracking-[0.2em] text-neutral-500 mb-2">Phase 7</div>
        <h1 className="font-display text-3xl md:text-4xl text-neutral-900 flex items-center gap-3">Betrieb <Activity className="w-6 h-6 text-[#183153]" /></h1>
        <p className="text-sm text-neutral-600 mt-2">Health-Checks anstoßen und Ergebnisse nachverfolgen.</p>
      </div>

      <div className="flex flex-wrap items-center gap-3 mb-4">
        <select value={projectId} onChange={(e) => setProjectId(e.target.value)} data-testid="operations-project-select" className="px-3 py-2 border border-neutral-300 rounded-sm text-sm">
          <option value="">Projekt wählen…</option>
          {projects.map((p) => <option key={p.project_id} value={p.project_id}>{p.name}</option>)}
        </select>
        <button onClick={() => trigger("smoke")} disabled={!projectId} data-testid="operations-smoke-button" className="inline-flex items-center gap-2 px-3 py-2 text-sm border border-neutral-300 rounded-sm hover:bg-neutral-50 disabled:opacity-50">
          <Play className="w-3.5 h-3.5" /> Smoke-Test
        </button>
        <button onClick={() => trigger("health")} disabled={!projectId} data-testid="operations-health-button" className="inline-flex items-center gap-2 px-3 py-2 text-sm text-white rounded-sm disabled:opacity-50" style={{ background: "#183153" }}>
          <Play className="w-3.5 h-3.5" /> Health-Check
        </button>
      </div>

      {projectId && (
        <div className="bg-white border border-neutral-200">
          <table className="w-full text-sm">
            <thead className="border-b border-neutral-200 bg-neutral-50">
              <tr className="text-left">
                <th className="px-5 py-2 font-mono text-[10px] uppercase tracking-widest text-neutral-500">Check</th>
                <th className="px-5 py-2 font-mono text-[10px] uppercase tracking-widest text-neutral-500">Typ</th>
                <th className="px-5 py-2 font-mono text-[10px] uppercase tracking-widest text-neutral-500">Status</th>
                <th className="px-5 py-2 font-mono text-[10px] uppercase tracking-widest text-neutral-500">Latency</th>
                <th className="px-5 py-2 font-mono text-[10px] uppercase tracking-widest text-neutral-500">Uptime</th>
                <th className="px-5 py-2 font-mono text-[10px] uppercase tracking-widest text-neutral-500">Errors 24h</th>
                <th className="px-5 py-2 font-mono text-[10px] uppercase tracking-widest text-neutral-500">Erstellt</th>
              </tr>
            </thead>
            <tbody>
              {checks.length === 0 && <tr><td colSpan={7} className="px-5 py-10 text-center text-neutral-500">Noch keine Health-Checks.</td></tr>}
              {checks.map((c) => (
                <tr key={c.check_id} className="border-b border-neutral-100">
                  <td className="px-5 py-3 font-mono text-xs">{c.check_id}</td>
                  <td className="px-5 py-3 text-sm">{c.type}</td>
                  <td className="px-5 py-3"><StatusPill kind="status" value={c.status} sharp /></td>
                  <td className="px-5 py-3 font-mono tabular text-xs">{c.result?.latency_ms} ms</td>
                  <td className="px-5 py-3 font-mono tabular text-xs">{c.result?.uptime}</td>
                  <td className="px-5 py-3 font-mono tabular text-xs" style={{ color: c.result?.errors_24h ? "#991B1B" : "#525252" }}>{c.result?.errors_24h ?? 0}</td>
                  <td className="px-5 py-3 font-mono text-xs text-neutral-500">{fmtDate(c.created_at)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </InternalLayout>
  );
}
